import { LeadForm, SaveLeadFormDraftParams } from "@plura/shared/types";

/**
 * Converts a LeadForm to SaveLeadFormDraftParams
 * This is useful for editing existing forms or extracting template data
 * 
 * @param leadForm - The complete LeadForm object from the database
 * @returns SaveLeadFormDraftParams object that can be used to update the form
 */
export const convertLeadFormToDraftParams = (
  leadForm: LeadForm,
): SaveLeadFormDraftParams => {
  return {
    // Collection reference
    collectionId: leadForm.collectionId,

    // Style settings
    fontSizeSetting: leadForm.fontSizeSetting,
    transitionType: leadForm.transitionType,
    transitionSpeed: leadForm.transitionSpeed,
    elementType: leadForm.elementType,
    backgroundColorSetting: leadForm.backgroundColorSetting,
    textColorSetting: leadForm.textColorSetting,
    buttonColorSetting: leadForm.buttonColorSetting,
    buttonTextColorSetting: leadForm.buttonTextColorSetting,
    answerColorSetting: leadForm.answerColorSetting ?? null,
    fontFamilySetting: leadForm.fontFamilySetting ?? 'Inter',

    // Form content
    name: leadForm.name ?? 'Untitled Form',
    overview: leadForm.overview ?? undefined,
    about: leadForm.about ?? undefined,
    tone: leadForm.tone ?? undefined,

    // Form settings
    hideBuiltWithBadge: leadForm.hideBuiltWithBadge,
    closed: leadForm.closed,
    closedMessage: leadForm.closedMessage ?? undefined,
    legalDisclaimer: leadForm.legalDisclaimer,
    legalMessage: leadForm.legalMessage ?? undefined,
    notifications: leadForm.notifications,
    notificationEmail: leadForm.notificationEmail ?? undefined,
    logoUrl: leadForm.logoUrl ?? undefined,
    logoPosition: leadForm.logoPosition ?? 'TOP_LEFT',
    skipWelcomeScreen: leadForm.skipWelcomeScreen,
    showTimeToComplete: leadForm.showTimeToComplete ?? true,
    showAnswerLetters: leadForm.showAnswerLetters ?? true,
    customEndScreen: leadForm.customEndScreen ?? false,

    // Tracking and integrations
    googleTagManager: leadForm.googleTagManager ?? undefined,
    metaPixel: leadForm.metaPixel ?? undefined,
    assistantId: leadForm.assistantId ?? undefined,

    // Metadata
    metaTitle: leadForm.metaTitle ?? undefined,
    metaDescription: leadForm.metaDescription ?? undefined,
    metaImageUrl: leadForm.metaImageUrl ?? undefined,
    consentMessageTitle: leadForm.consentMessageTitle ?? undefined,

    // GDPR and privacy settings
    gdprSetting: leadForm.gdprSetting,
    gdprRequired: leadForm.gdprRequired,

    // Form data
    hiddenFields: leadForm.hiddenFields ?? [],
    journeyItems: leadForm.journeyItems ?? undefined,
    snippets: leadForm.snippets ?? undefined,
  };
};

